import { Component } from 'react';

export default class JumpLinkIcon extends Component {
  render() {
    return (
      <svg width="28px" height="15px" viewBox="0 0 28 15">
        <title>Jumplink icon</title>
        <g
          id="SMARTLINK-V3"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Smartlink-page---2"
            transform="translate(-1004.000000, -486.000000)"
            fill="#FFFFFF"
          >
            <path
              d="M1022.66667,486.033333 L1022.66667,489.766667 C1005.86667,489.766667 1004,499.1 1004,500.966667 C1005.86667,497.233333 1010.06667,496.3 1014.03333,496.3 C1018,496.3 1021.73333,497.233333 1022.66667,497.233333 L1022.66667,500.966667 L1032,493.5 L1022.66667,486.033333"
              id="Jumplink-icon"
            ></path>
          </g>
        </g>
      </svg>
    );
  }
}
